<script setup lang="ts">
import { useStudentRecipientLabel } from '@/composables/useStudentRecipientLabel';
import { useContainerTranslations } from '@/schoolClasses/useContainerTranslations';
import type { IGenericUser } from '@/interfaces';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  students: IGenericUser[];
  wholeClassSelected: boolean;
}>();

const { t } = useI18n();
const { getStudentRecipientLabel } = useStudentRecipientLabel();
const { tContainer } = useContainerTranslations();

const label = computed(() => {
  if (props.wholeClassSelected) {
    return tContainer('collectiveRatingWholeSelection');
  }

  return t('quickEntry.collectiveRatingStudents', {
    students: getStudentRecipientLabel({ students: props.students }).label,
  });
});
</script>

<template>
  <p aria-live="polite" class="px-md py-xs text-footer-semibold text-secondary">
    {{ label }}
  </p>
</template>
